import { Select } from '@octano/global-ui';
import { useGetDateFilterOptions } from '../hooks/useGetDateFilterOptions';
import { useTexts } from '../hooks/useTexts';
import { useAttendancesTableFetch } from './AttendancesTableLoader';

type Props = {
  selectDate: number;
  setSelectDate: (date: number) => void;
};

export function DateFilter({ selectDate, setSelectDate }: Props) {
  const { updateQuery } = useAttendancesTableFetch();
  const dateFilterOptions = useGetDateFilterOptions();
  const texts = useTexts();

  function changeDate(event: {
    label: string;
    value: number;
    monthsDiff: number;
  }) {
    setSelectDate(event.value);
    updateQuery({ initDate: event.value, currentPage: 0 });
  }

  return (
    <Select
      isSearchable={false}
      isClearable={false}
      label={texts.dateFilterOptions.filterLabel}
      name="date"
      value={dateFilterOptions.find((item) => item.value === selectDate)}
      onChange={(e) => changeDate(e)}
      options={dateFilterOptions}
    />
  );
}
